import { render, staticRenderFns } from "./ShopBoxEditComponent.vue?vue&type=template&id=67959dc6&scoped=true"
import script from "./ShopBoxEditComponent.vue?vue&type=script&lang=js"
export * from "./ShopBoxEditComponent.vue?vue&type=script&lang=js"
import style0 from "./ShopBoxEditComponent.vue?vue&type=style&index=0&id=67959dc6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67959dc6",
  null
  
)

export default component.exports